import {ColumnFactory, ColumnWidth, ControlRoomColumn} from "../../common/ui/table/ControlRoomColumns";
import {Role} from "../../user/model";
import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";

import * as React from "react";

import {Button} from "react-bootstrap";
import {LcdIcon} from "../../common/ui/icon/LcdIcon";

type ColumnEntry = ControlRoomColumn<Role>;

const ROLE_CONTENT_MESSAGES: {[key:string]:ReactIntl.FormattedMessage.MessageDescriptor} = {
    deleteTooltip: {
        id: "studio.products.role-content-list.delete-role",
        defaultMessage: "Delete role",
    },
};

export class RolesContentColumnFactory implements ColumnFactory<Role>{
  private readonly removeItem: (role: Role) => void;
    private changeItem: (role: Role) => void;
  private readonly canEdit: boolean;

    constructor(options: {canEdit: boolean; removeItem?: (role: Role) => void, changeItem?: (role: Role) => void}) {
        if (options.canEdit) {
            this.removeItem =  options.removeItem;
            this.changeItem =  options.changeItem;
        }
        this.canEdit = options.canEdit;
    }

    createColumn(columnID: string): ControlRoomColumn<Role> {
        return this.columns[columnID];
    }

    getAvailableColumnIDs(): string[] {
        const availableColumnIDs = [];
        for (const prop in this.columns) {
            if (this.columns.hasOwnProperty(prop) ) {
                if (prop==="actions") {
                    if (this.canEdit) {
                        availableColumnIDs.push(prop);
                    }
                } else {
                    availableColumnIDs.push(prop);
                }
            }
        }
        return availableColumnIDs;
    }

    getInitialColumnIDs(): string[] {
        return this.getAvailableColumnIDs();
    }

    getInitialColumnWidth(columnID: string): ColumnWidth {
        return this.columns[columnID].columnWidth || ColumnWidth.pixels(200);
    }

    columns: { [columnID: string]: ColumnEntry } = {
        name: {
            header: <FormattedMessage id="studio.roles-content-list.role-name" defaultMessage="Role Name"/>,
            cellContent: (role) => {
                return <Link to={`/settings/roledetails/${encodeURIComponent(role.role)}`}>{role.role}</Link>;
            },
            cellTooltip: (role) => role.role,
            columnWidth: ColumnWidth.flex(2),
        },
        description: {
            header: <FormattedMessage id="studio.roles-content-list.role-description" defaultMessage="Description"/>,
            cellContent: (role) => {
                return role.description;
            },
            cellTooltip: (role) => role.description,
            columnWidth: ColumnWidth.flex(8),
        },
        actions: {
            header: <FormattedMessage id="studio.roles-content-list.delete" defaultMessage="Delete"/>,
      cellContent: (role) => {
                return (
                    <Button className="btn-icon"
                                style={{backgroundColor: "transparent", color: "currentColor", border: "1px solid transparent"}}
                                onClick={(event) => {
                                    event.stopPropagation();
                      if (typeof this.removeItem === "function") {
                        this.removeItem(role);
                      }
                                }}
                    >
                        <LcdIcon icon="delete"/>
                    </Button>);
            },
            cellTooltip: (styledData, intl) => intl.formatMessage(ROLE_CONTENT_MESSAGES.deleteTooltip),
            columnWidth: ColumnWidth.pixels(80),
        },
    }
}
